import React from 'react';
import { array } from 'prop-types';

import { connect } from 'react-redux';

import MaterialTable from 'material-table';

import classes from './ProfileTable.module.css';

const ProfileTable = ({
    targetProfiles,
    ...props
}) => {

    return (
        <div className={classes.ProfileTable}>
            <div className={classes.title}>
                <h2>Available Profiles</h2>
            </div>
            <div className={classes.tableContainer}>
                <MaterialTable
                    options={{
                        paging:    false,
                        showTitle: false,
                        search:    false,
                        selection: false,
                        toolbar:   false,
                        filtering: true
                    }}
                    columns={[
                        { title: 'Profile', field: 'name' },
                        { title: 'Profile Type', field: 'profileType' },
                        {
                            title:  'Device Count',
                            render: rowData => rowData.devices.length
                        }
                    ]}
                    data={targetProfiles}
                    detailPanel={rowData => (
                        <div className={classes.subTable}>
                            <MaterialTable
                                options={{
                                    paging:    false,
                                    showTitle: false,
                                    search:    false,
                                    selection: false,
                                    toolbar:   false
                                }}
                                columns={[
                                    { title: 'Device Name', field: 'name' }
                                ]}
                                data={rowData.devices}
                            />
                        </div>
                    )}
                />
            </div>
        </div>
    );
};

ProfileTable.defaultProps = {
    targetProfiles: []
};

ProfileTable.propTypes = {
    targetProfiles: array
};

const mapStateToProps = state => {
    return {
        targetProfiles: state.wizard.targetProfiles
    };
};

export default connect(mapStateToProps, null)(ProfileTable);
